import { action, computed, makeObservable, observable } from 'mobx';

import { ModalState } from '../../shared/ModalState';
import StoreSelectionState from '../StoreSelectionState';

export enum StoreSelectionReason {
  CurrentStoreDifferentThanPreffered = 'CurrentStoreDifferentThanPreffered',
  CurrentStoreDifferentThanSelectedByLocation = 'CurrentStoreDifferentThanSelectedByLocation',
  CurrentStoreSelectedByLocation = 'CurrentStoreSelectedByLocation',
}

interface StoreSelectorPopupContext {
  reason: StoreSelectionReason;
  suggestedStoreId: string;
}

export default class StoreSelectorPopupState extends ModalState {
  @observable
  public reason: StoreSelectionReason | undefined = undefined;

  @observable
  public suggestedStoreId: string | undefined = undefined;

  @computed
  public get currentStore() {
    return this.storeSelection.currentStore;
  }

  @computed
  public get suggestedStore() {
    return this.storeSelection.stores.find((x) => x.id === this.suggestedStoreId);
  }

  public get stores() {
    return this.storeSelection.stores;
  }

  public constructor(private readonly storeSelection: StoreSelectionState) {
    super();
    makeObservable(this);
  }

  @action.bound
  public changeStore(storeKey: string) {
    this.storeSelection.selectStore(storeKey, this.storeSelection.currentLanguage.code);
  }

  @action.bound
  public setContextAndOpen(context: StoreSelectorPopupContext) {
    this.reason = context.reason;
    this.suggestedStoreId = context.suggestedStoreId;
    this.open();
  }

  @action.bound
  public setReason(reason: StoreSelectionReason) {
    this.reason = reason;
  }

  @action.bound
  public setSuggestedStoreId(storeId: string) {
    this.suggestedStoreId = storeId;
  }

  @action.bound
  public cancel() {
    this.preserveCurrentStore();
    this.close();
  }

  private preserveCurrentStore() {
    const store = this.stores.find((x) => x.key === this.currentStore.key);
    this.storeSelection.setStore(store);
  }
}
